<script lang="ts">
    export let label: string;
    export let alignToEnd = false;
    export let withoutBiggerValueText = false;
    export let fillWidth = false;
    export let additionalClasses = '';
</script>

<div class="labeled-value-container {additionalClasses}"
     class:align-to-end={alignToEnd}
     class:fill-width={fillWidth}
     class:bigger-value-text={!withoutBiggerValueText}>

    <span class="value-label">{label}</span>

    <span class="value">
        <slot/>
    </span>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .labeled-value-container {
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: @spacing-xs;

        &.fill-width {
            width: 100%;

            .value-label, .value {
                width: 100%;
            }
        }

        &.align-to-end {
            align-items: end;
        }

        &.bigger-value-text {
            .value {
                font-size: @font-size-large;
                font-weight: 500;
            }
        }

        .value-label {
            white-space: nowrap;
            font-size: @font-size-small;
            color: @themed-text-muted;
        }

        .value {
            white-space: nowrap;
        }
    }
</style>